import { configureStore } from '@reduxjs/toolkit'

import activeLocationReducer from '@/core/store/slices/activeLocationSlice'
import activeZoneReducer from '@/core/store/slices/activeZoneSlice'
import { authReducer } from '@/core/store/slices/auth'
import { campaignFlowReducer } from '@/core/store/slices/campaignFlowSlice'
import { fetchAllDataReducer } from '@/core/store/slices/fetchAllDataSlice'
import { globalPlayerReducer } from '@/core/store/slices/globalPlayer'
import { selectedAccountReducer } from '@/core/store/slices/selectedAccountSlice'
import { uiReducer } from '@/core/store/slices/ui'
import { zonesReducer } from '@/core/store/slices/zones'

export const store = configureStore({
	reducer: {
		auth: authReducer,
		ui: uiReducer,
		globalPlayer: globalPlayerReducer,
		zones: zonesReducer,
		activeZone: activeZoneReducer,
		activeLocation: activeLocationReducer,
		campaignFlow: campaignFlowReducer,
		selectedAccount: selectedAccountReducer,
		fetchAllData: fetchAllDataReducer,
	},
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware({
			serializableCheck: false,
		}),
})

// Infer the `RootState` and `AppDispatch` types from the store
export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
